module.exports = __webpack_public_path__ + "static/img/icon_pd_includeex.d1e16d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon_pd_includeex.png
// module id = Gxnp
// module chunks = 1